import * as React from "react";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import usePermissions from "hooks/usePermissions";
const CreateHealthAlertButton = ({ onClick }) => {
  const { isPermitted } = usePermissions();
  if (!isPermitted("eventdefinitions:create")) return null;
  return /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small", onClick }, /* @__PURE__ */ React.createElement(Icon, { name: "notifications" }), " Create alert");
};
export default CreateHealthAlertButton;
